import img1 from "../../../../../shared/images/7.jpg";
import img2 from "../../../../../shared/images/8.jpg";
import img3 from "../../../../../shared/images/9.jpg";
import img4 from "../../../../../shared/images/10.jpg";
import img5 from "../../../../../shared/images/11.jpg";

export const FeaturedListingsData = [
  {
    id: 1,
    img: img1,
    title: "Villa in Rego Park",
  },
  { id: 2, img: img2, title: "Beautiful Flat" },
  {
    id: 3,
    img: img3,
    title: "Modern Apartment",
  },
  {
    id: 4,
    img: img4,
    title: "New Apartment Nice View",
  },
  {
    id: 5,
    img: img5,
    title: "Comfortable Apartment",
  },
];
